import { put, select, all, takeEvery } from 'redux-saga/effects'

import { Game, Api, Auth, Firebase } from '../../../Core'
import EndGameScreen from './index'
import * as actions from './endgame.actions'
import * as quizzesSelectors from '../../Quizzes/quizzes.selectors'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as rankingSelector from '../../Ranking/ranking.selectors'
import * as utils from '../../Quizzes/quizzes.utils'

import * as quizzesSagas from '../../Quizzes/quizzes.sagas'
function* init() {
  // yield put(phasesActions.goToPhase(3))
  yield loadComponents()
}

/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    EndGameScreen,
  }
  yield put(Game.actions.registerComponents(components))
}

export function* loadReportData() {
  let report
  try {
    const summary = yield Api.get('/questions/summary', {})
    const userInfo = yield select(Auth.selectors.getUserInfo)
    const federationsInfo = yield select(Firebase.selectors.getFederationsInfo)
    const indicators = yield select(indicatorsSelectors.getUserData)
    const disputeList = yield select(quizzesSelectors.getDisputesList)
    const podium = yield select(rankingSelector.getPodium)
    const federationData = federationsInfo ? yield getFederationData() : {}

    let podiumCorrectAnswers = {}

    for (let i = 0; i < podium.length; i++) {
      const user = podium[i]
      const userQuestions = yield quizzesSagas.getUserQuestions(
        user.licenseId,
        userInfo.licenseData.groupId
      )
      podiumCorrectAnswers[user.licenseId] = {
        rightAnswered: utils.getTotalCorrectAnswers(userQuestions.answerList),
        answered: userQuestions.answerList.length,
      }
    }

    report = {
      disputeList,
      indicators,
      podium,
      podiumCorrectAnswers,
      ...federationData,
      debated: summary.numQuestionsVoted,
      disputed: summary.numQuestionsDisputedByMe,
      disputedToMe: summary.numQuestionsDisputedToMe,
    }
  } catch (e) {
    console.log(e)
    report = {
      disputeList: null,
      indicators: null,
      podium: null,
      podiumCorrectAnswers: null,
      debated: null,
      disputed: null,
      disputedToMe: null,
    }
  }

  yield put(actions.setReports(report))
  yield put(Game.actions.addScreen('end_game'))
}

function* getFederationData() {
  const federationsPodium = yield select(rankingSelector.getFederationPodium)

  let federationCorrectAnswers = {}

  for (let federation of federationsPodium) {
    const federationQuestions = yield quizzesSagas.getFederationCorrectAnswers(federation.name)
    federationCorrectAnswers[federation.name] = federationQuestions
  }
  return { federationsPodium, federationCorrectAnswers }
}
/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield all([init(), yield takeEvery(actions.LOAD_DATA, loadReportData)])
}
